import { BankAccount, PaymentMethod, WirePaymentMethod } from 'types/payment';

export const isBankPaymentMethod = (paymentMethod: PaymentMethod): paymentMethod is BankAccount => {
	return paymentMethod?.hasOwnProperty('routingNumber');
};

export const isWirePaymentMethod = (paymentMethod: PaymentMethod): paymentMethod is WirePaymentMethod => {
	return paymentMethod?.hasOwnProperty('wirePaymentMethodId');
};
